module.exports = function() {
  return new Worker(__webpack_public_path__ + "web-worker.339d200f9181c8dd56c0.js");
};